{
  "z-index": {
    "z-index-base": 0,
    "z-index-dropdown": 1000,
    "z-index-sticky": 1100,
    "z-index-overlay": 1200,
    "z-index-modal": 1300,
    "z-index-popover": 1400,
    "z-index-toast": 1500,
    "z-index-tooltip": 1600
  }
}
